import React, { useState, useEffect } from 'react'
import { getListEmbroideryError } from '../../../services/api/3dApi'
import { Link } from 'react-router-dom'
import { Icon, Pagination, Select, Spin, message, AutoComplete, Input } from 'antd'
import { getListBrand, listPartner } from '../../../services/api/3dApi'
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import FilterProductType from '../../batchesV3/components/filters/FilterProductType'
import UseDebounce from '../../users/helpers/UseDebounce'
import queryString from 'query-string'
import SelectFilterOptions from '../../shared/SelectFilterOptions'
import { TAGS } from '../../../helpers/ListOptions.json'
import EmbroideryErrorTable from './EmbroideryErrorTable'
import QueryString from 'qs'
import { ERROR_EMBROIDERED } from "../../batches-mark-qc-v3/contant/ListOption.json"

function EmbroideryErrorPage() {
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [listEmbroideryError, setListEmbroideryError] = useState([])
    const [type, setType] = useState([])
    const [listBrand, setListBrand] = useState([])
    const [brand, setBrand] = useState([])
    const [errorType, setErrorType] = useState('')
    const [markErrorAt, setMarkErrorAt] = useState({})
    const [allPartner, setAllPartner] = useState([])
    const [overTime, setOverTime] = useState([])
    const [printPartner, setPrintPartner] = useState('')
    const [tags, setTags] = useState([])
    const [selectedBatchId, setSelectedBatchId] = useState([])
    const [selectedAll, setSelectedAll] = useState(false)

    const debounceError = errorType === '' ? UseDebounce(errorType, 0) : UseDebounce(errorType, 500)

    const _getAllPartner = async () => {
        const payload = {
            limit: 10000,
            page: 1,
            hidden: false,
        }
        try {
            const query = queryString.stringify(payload)
            const { data: Data } = await listPartner(query)
            const { data, success, message } = Data
            if (success) {
                setAllPartner(data.partners)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const _getListBrand = async () => {
        const payload = {
            limit: 10000,
            page: 1
        }
        try {
            const { data: Data } = await getListBrand(payload)
            const { data, success, message } = Data
            const Brands = data.Brands.map(i => ({ value: i.name, label: i.name }))
            if (success) {
                setListBrand(Brands)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchEmbroideryError = async () => {
        setLoading(true)

        try {
            const query = Object.assign({}, {
                status: ["pending"],
                sku: !!type.length ? type : [],
                type_error: !!errorType ? [errorType] : [],
                brand_name: !!brand.length ? brand : [],
                overtime: !!overTime.length ? overTime : [],
                partner: !!printPartner ? [printPartner] : [],
                tag: !!(Array.isArray(tags) && tags.length > 0) ? tags : []
            })

            if(!!Object.keys(markErrorAt).length && markErrorAt.from && markErrorAt.to) query.mark_error_at = markErrorAt

            const params = QueryString.stringify({ query, page, limit })
            const { data: res } = await getListEmbroideryError(params)

            const { data, success, error } = { ...res }
            if (success) {
                setListEmbroideryError(data.items)
                setTotal(data.total)
                setPage(data.page)
                setLimit(data.limit)
            } else {
                setError(error)
                message.error(error)
            }
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        }
        finally {
            setLoading(false)
        }
    }

    const handleChangeType = (value) => {
        setType(value)
        setPage(1)
    }

    const handleChangeErrorType = (value) => {
        setErrorType(value)
        setPage(1)
    }

    const handleChangeBrand = (value) => {
        setBrand(value)
        setPage(1)
    }

    const handleChangeMarkErrorAt = (field, value) => {
        setMarkErrorAt(value)
        setPage(1)
    }

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    useEffect(() => {
        fetchEmbroideryError()
    }, [limit, page, brand, debounceError, type, markErrorAt, printPartner, overTime, tags])

    useEffect(() => {
        _getListBrand()
        _getAllPartner()
    }, [])

    const { Option } = Select
    const disableNoBrand = !!brand && brand.length > 0 && !brand.includes('no brand')
    const disableOptionBrand = !!brand && brand.length > 0 && brand.includes('no brand')

    function _resetSelected() {
        setSelectedAll(false)
        setSelectedBatchId([])
    }
    function _toggleSelectAll(isChecked) {
        if (isChecked) {
            const listIds = []

            listEmbroideryError.map(item => listIds.push(item.item._id))

            setSelectedBatchId(listIds)
            setSelectedAll(true)
        } else {
            setSelectedBatchId([])
            setSelectedAll(false)
        }
    }
    function _updateSelectedBatches(id, isAdded) {
        if (isAdded && !selectedBatchId.includes(id)) {
            setSelectedBatchId([...selectedBatchId, id])
            setSelectedAll(selectedBatchId.length + 1 === listEmbroideryError.length)
        } else {
            const filtered = selectedBatchId.filter(batch => batch !== id)

            setSelectedBatchId(filtered)
            setSelectedAll(false)
        }
    }

    const getOptionOverTime = (start, end) => {
        const Options = []
        for (let i = start; i <= end; i++) {
            if(i !==0){
                const Option = {
                    name: i,
                    value: i,
                }
                if(i === -1) {
                    Options.push({name: -1.5,value: -1.5,})
                }
                Options.push(Option)
            }
        }
        return Options
    }

    const handleChangeOverTime = (field, value) => {
        setOverTime([...value])
    }

    const handleChangePartner = (name, value) => {
        if(name === 'printPartner') {
            setPrintPartner(value)
        }
    }

    const handleChangeTag = (tag) => {
        setTags(tag)
    }

    const listPrintPartner = allPartner.filter(i => i.type_partner === 'print_partner')

    return (
        <div className='EmbroideryErrorPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Danh sách item lỗi thêu</h3>
                        <div className='d-flex align-items-center'>
                            <Link
                                className='ant-btn ml-3'
                                to='embroidery-error-in-batch'
                                disabled={loading}
                            >
                                Thống kê lỗi thêu
                            </Link>
                        </div>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-12 col-xl-4 mb-3'>
                                <label className='font-weight-bold d-block'>Loại sản phẩm:</label>
                                <FilterProductType
                                    productTypes={type}
                                    onChangeProductType={handleChangeType}
                                />
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block">Ngày báo lỗi</label>
                                <FilterDateRangeV2
                                    field='mark_error_at'
                                    onDatesChange={handleChangeMarkErrorAt}
                                />
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label htmlFor="error_type" className="Error font-weight-bold d-block">Loại lỗi:</label>
                                <AutoComplete
                                    options={ERROR_EMBROIDERED}
                                    dataSource={ERROR_EMBROIDERED}
                                    filterOption={(inputValue, option) =>
                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    onChange={handleChangeErrorType}
                                    allowClear
                                    placeholder="Search loại lỗi"
                                    className='w-100'
                                >
                                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                                </AutoComplete>
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label for="request_update" className="font-weight-bold d-block">Brand</label>
                                <Select
                                    name='brand'
                                    className='brand'
                                    mode={'multiple'}
                                    onChange={(value) => handleChangeBrand(value)}
                                    value={brand}
                                    allowClear
                                    showArrow
                                    placeholder='Chọn brand name'
                                    style={{ width: '100%' }}
                                >
                                    <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                                    {listBrand.length && listBrand.map((i, index) => (
                                        <Option disabled={disableOptionBrand} value={i.value} key={index}>{i.label}</Option>
                                    ))
                                    }
                                </Select>
                            </div>
                            <div className='col-12 col-xl-2 mb-3 filterBrand RequestSelect'>
                                <SelectFilterOptions
                                    defaultValue={overTime}
                                    listOptions={getOptionOverTime(-6, 6)}
                                    style={{ width: '100%' }}
                                    field="overtime" label="Thời gian item quá hạn"
                                    handleChange={handleChangeOverTime}
                                    mode='multiple'
                                    showArrow
                                    allowClear
                                    placeholder='Chọn thời gian item quá hạn'
                                />
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block">Đối tác</label>
                                <Select
                                    onChange={(value) => handleChangePartner('printPartner', value)}
                                    value = {printPartner || []} 
                                    style={{ width: '100%' }} 
                                    placeholder='Chọn đối tác' 
                                    allowClear
                                    dropdownClassName='custom-select-partner'
                                >
                                    {
                                        listPrintPartner.length > 0 && listPrintPartner.map(item => {
                                            return <Option key={item._id} value={item._id}>{item.name}</Option>
                                        })
                                    }
                                </Select>
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label htmlFor="error_type" className="Error font-weight-bold d-block">Tags</label>
                                <Select
                                    mode='multiple'
                                    onChange={handleChangeTag}
                                    value={tags || []} 
                                    style={{ width: '100%' }} 
                                    placeholder='Chọn tag'
                                    filterOption={(input, option) => 
                                        option.props.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0 
                                    } 
                                    allowClear
                                >
                                    {
                                        TAGS.map((item, index) =>
                                            <Option key={index} value={item.value}>
                                                {item.name}
                                            </Option>
                                        )
                                    }
                                </Select>
                            </div>
                        </div>

                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} items`}</strong>
                                </div>}
                            onChange={handlePageChange}
                            onShowSizeChange={handleShowSizeChange}
                            disabled={loading}
                        />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <EmbroideryErrorTable
                            listEmbroideryError={listEmbroideryError}
                            selectedBatchId={selectedBatchId}
                            selectedAll={selectedAll}
                            setType={setType}
                            setBrand={setBrand}
                            onResetSelected={_resetSelected}
                            onSelectAll={_toggleSelectAll}
                            onUpdateSelectedBatches={_updateSelectedBatches}
                            reset={fetchEmbroideryError}
                        />
                    </Spin>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        onShowSizeChange={handleShowSizeChange}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default EmbroideryErrorPage